import React from 'react';
import { WebsiteDesignProps } from './types';
import { Key, Map, Search } from 'lucide-react';
import { Button } from "@/components/ui/button";

const RealEstatePrime: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Estate Academy";

    return (
        <div className="bg-black text-white min-h-screen font-serif">
            <nav className="border-b border-white/20 p-8 flex justify-between items-center bg-[#0a0a0a]">
                <div className="text-2xl font-light uppercase tracking-[0.2em] flex items-center gap-2">
                    <span className="text-[#c5a059]">|</span> {schoolName}
                </div>
                <div className="flex gap-8 text-xs font-sans font-bold uppercase tracking-widest">
                    <a href="#" className="hover:text-[#c5a059] transition-colors">Brokerage</a>
                    <a href="#" className="hover:text-[#c5a059] transition-colors">Investments</a>
                    <a href="#" className="hover:text-[#c5a059] transition-colors">Academy</a>
                </div>
            </nav>

            <header className="relative py-32 px-8">
                <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                    <div>
                        <div className="text-[#c5a059] uppercase tracking-widest text-xs font-sans font-bold mb-4">
                            Premium Education
                        </div>
                        <h1 className="text-5xl md:text-7xl font-light mb-8 leading-tight">
                            The Key to <br/> <span className="italic font-serif text-[#c5a059]">Success</span>
                        </h1>
                        <p className="text-gray-400 font-sans text-lg mb-10 max-w-md leading-relaxed">
                            Master the art of real estate sales, negotiation, and property management with the industry's elite.
                        </p>
                        <Button className="bg-[#c5a059] text-black hover:bg-white rounded-none px-10 py-6 uppercase font-sans font-bold text-xs tracking-widest">
                            Join the Agency
                        </Button>
                    </div>
                    <div className="relative">
                        <div className="aspect-[4/5] bg-gray-900 border border-white/10">
                            <img src="https://images.unsplash.com/photo-1560518883-ce09059ee971?q=80&w=2073&auto=format&fit=crop" className="w-full h-full object-cover opacity-80" alt="Skyline" />
                        </div>
                        <div className="absolute -bottom-8 -left-8 bg-[#0a0a0a] border border-[#c5a059] p-8 max-w-xs">
                             <div className="text-[#c5a059] text-3xl font-light mb-2">120+</div>
                             <div className="text-xs font-sans uppercase tracking-widest text-gray-400">Hours of Licensing Courses</div>
                        </div>
                    </div>
                </div>
            </header>

            <section className="border-t border-white/10 py-20 bg-[#0f0f0f] font-sans">
                <div className="container mx-auto px-8 grid grid-cols-1 md:grid-cols-3 gap-8">
                    {[
                        { icon: Key, title: "Licensing", desc: "State-approved curriculum for new agents." },
                        { icon: Search, title: "Market Analysis", desc: "Data-driven insights for smart investing." },
                        { icon: Map, title: "Development", desc: "Understanding zoning, land use, and builds." }
                    ].map((item, i) => (
                        <div key={i} className="p-8 border border-white/5 hover:border-[#c5a059] transition-colors">
                            <item.icon className="text-[#c5a059] mb-4" size={28} />
                            <h3 className="text-lg font-bold uppercase tracking-widest text-white mb-2">{item.title}</h3>
                            <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default RealEstatePrime;
